export const publicURL = process.env.PUBLIC_URL;
export const websiteTitle = process.env.REACT_APP_WEBSITE_TITLE;
export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
export const infuraKey = process.env.REACT_APP_INFURA_KEY;
export const openSeaUrl = process.env.REACT_APP_OPENSEA_URL || "";
